import { Injectable } from '@angular/core';
import { hasOnePermission } from '../internal-settings/internal-settings.service';
import { InternalSettings, PermissionList } from '../internal-settings/internal-settings.interface';
import { ExternalSettings } from '../external-settings/external-settings.interface';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor() { }

  /**
   * Static Method to check if user has permission to view the order templates
   */
  static isAllowListTemplate(internalSettings: InternalSettings, externalSettings: ExternalSettings) {
    if (!externalSettings.globalVariables.isModuleEnabledOrderTemplates) return false;
    return hasOnePermission([PermissionList.MANAGE_ORDER_TEMPLATES], internalSettings.permissions);
  }

  
  /**
   * Static Method to check if user has permission to show menu item
   */
  static isAllowTemplateMenu(internalSettings: InternalSettings, externalSettings: ExternalSettings) {
    if (!OrderService.isAllowListTemplate(internalSettings, externalSettings)) return false;

    let isCompanyUser = internalSettings.profile.isCompanyUser;
    let isCompanyAdmin = internalSettings.profile.isCompanyAdmin;
    let isSharedCompanyOrderTemplates = externalSettings.globalVariables.isSharedCompanyOrderTemplates;

    let isAllowed = true;
    if (isSharedCompanyOrderTemplates && isCompanyUser && !isCompanyAdmin) {
      isAllowed = false;
    }

    return isAllowed;
  }

  /**
   * Static Method to check if user has permission to save the order templates
   */
  static isAllowSaveTemplate(internalSettings: InternalSettings, externalSettings: ExternalSettings) {
    if (!OrderService.isAllowListTemplate(internalSettings, externalSettings)) return false;

    let isCompanyUser = internalSettings.profile.isCompanyUser;
    let isCompanyAdmin = internalSettings.profile.isCompanyAdmin;
    let isSharedCompanyOrderTemplates = externalSettings.globalVariables.isSharedCompanyOrderTemplates;

    let isAllowed = true;
    if (isSharedCompanyOrderTemplates && isCompanyUser && !isCompanyAdmin) {
      isAllowed = false;
    }

    return isAllowed;
  }

  /**
   * Static Method to check if user has permission to set schedule order
   */
  static isAllowScheduleOrder(internalSettings: InternalSettings) {
    return hasOnePermission([PermissionList.SCHEDULE_ORDERS], internalSettings.permissions);
  }

}
